import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const LEVEL_CLASS = {
    critical: 'sec-badge--priority-critical',
    high: 'sec-badge--priority-high',
    medium: 'sec-badge--priority-medium',
    low: 'sec-badge--priority-low',
};
/**
 * Prioritäts-Badge auf Basis der `.sec-badge--priority-*`-Klassen. Domänenfrei:
 * Aufrufer liefert Stufe, Label und ggf. Icon (die App-Mappings — Enum/Locale —
 * bleiben beim Aufrufer).
 */
export const PriorityBadge = forwardRef(function PriorityBadge({ level, label, icon, pulse, className, ...rest }, ref) {
    return (_jsxs("span", { ref: ref, role: "status", className: cn('sec-badge', LEVEL_CLASS[level], pulse && 'sec-badge--pulse', className), ...rest, children: [icon ? _jsx("span", { "aria-hidden": "true", children: icon }) : null, label] }));
});
